// extracted by mini-css-extract-plugin
export var contrastLow = "_2v-1";
export var externalLink = "_2v-2";
export var externalLinkIcon = "_2v-3";
export var link = "_2v-0";
export var linkLabel = "_2v-4";